// ---------------------------------------------------------------------------
// Constantes compartilhadas das telas de ESCRITA de movimento (entrada, saída
// e editor). Extraídas das três páginas em 2026-09-12, no redesenho — cada uma
// mantinha sua própria lista de `<option>` inline, com divergências reais
// (o editor oferecia DEVOLUÇÃO, a saída não).
//
// O enum canônico de `doc_type` é do backend (model Movement):
// NOTA FISCAL | DEVOLUÇÃO | PEDIDO DE VENDA | AJUSTE | TRANSFERÊNCIA.
// As listas por fluxo abaixo são um SUBCONJUNTO deliberado desse enum — mudar
// o que a operação pode lançar é decisão de negócio, não de refatoração.
//
// ⚠️ **TRANSFERÊNCIA saiu das três listas em 2026-09-12 (decisão do Caio):** o
// tipo passou a ser de uso EXCLUSIVO do submódulo de transferência entre PDVs
// (handoff 0099), que gera o par out/in com esse documento e mantém os
// acumuladores da ordem consistentes. Lançar "transferência" à mão criava um
// movimento que *parece* transferência e não tem ordem nenhuma atrás.
//
// O backend **continua aceitando** o valor (o enum não mudou) e há movimentos
// legados com ele na base — inclusive os gerados pela própria transferência.
// Logo:
//   · o EDITOR preserva o valor quando o movimento já o tem (a tela adiciona a
//     opção marcada como legado — ver `MovementEdit`), mas não permite
//     *converter* outro movimento para transferência;
//   · a identificação de "isto é uma transferência" segue sendo o campo
//     `transfer` dos reads, NUNCA `doc_type === 'TRANSFERÊNCIA'` — havia
//     lançamento manual legítimo com esse tipo antes desta data, e ele não
//     deixou de existir.
// ---------------------------------------------------------------------------

export const DOC_TYPE_OPTIONS_IN = [
   { value: 'NOTA FISCAL', label: 'NOTA FISCAL' },
   { value: 'AJUSTE', label: 'AJUSTE' },
   { value: 'DEVOLUÇÃO', label: 'DEVOLUÇÃO DE VENDA' },
   { value: 'PEDIDO DE VENDA', label: 'PEDIDO DE VENDA' },
];

export const DOC_TYPE_OPTIONS_OUT = [
   { value: 'NOTA FISCAL', label: 'NOTA FISCAL' },
   { value: 'PEDIDO DE VENDA', label: 'PEDIDO DE VENDA' },
   { value: 'AJUSTE', label: 'AJUSTE' },
];

export const DOC_TYPE_OPTIONS_EDIT = [
   { value: 'NOTA FISCAL', label: 'NOTA FISCAL' },
   { value: 'PEDIDO DE VENDA', label: 'PEDIDO DE VENDA' },
   { value: 'AJUSTE', label: 'AJUSTE' },
   { value: 'DEVOLUÇÃO', label: 'DEVOLUÇÃO' },
];

// Nº de documento e quantidade são inteiros na base — o campo recusa a tecla
// em vez de validar no submit.
export const INTEGER_RE = /^[0-9]+$/;

// Total de unidades da lista de itens (a contagem de linhas é `items.length`).
// A dupla "N itens · M un." aparece no badge da seção, no aside de resumo e
// (quando o backend expor os agregados) na coluna Itens da listagem.
export function sumItemUnits(items) {
   return (items ?? []).reduce(
      (total, item) => total + (Number(item.prod_qtd) || 0),
      0
   );
}
